var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 349,
    viewBox: "0 0 142 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.158 137.925C289.328 166.31 282.831 205.941 275.452 236.795C268.31 266.654 242.338 275.736 217.931 294.36C191.531 314.506 174.264 344.062 142.892 333.168C112.843 322.733 143.958 276.498 128.897 248.479C115.898 224.297 62.0996 210.74 62.326 183.286C62.6115 148.667 60.2445 87.4317 86.8539 65.2844C115.419 41.5092 151.454 95.6807 187.309 105.463C221.526 114.798 259.317 106.192 275.158 137.925Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M266.67 145.204C279.444 170.793 273.587 206.52 266.935 234.336C260.498 261.254 237.084 269.441 215.082 286.23C191.282 304.392 175.716 331.036 147.435 321.215C120.345 311.807 148.395 270.126 134.817 244.867C123.099 223.066 74.5994 210.844 74.8032 186.094C75.0601 154.885 72.9254 99.6812 96.9133 79.7156C122.664 58.2826 155.151 107.119 187.473 115.938C218.32 124.354 252.388 116.596 266.67 145.204Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.905 149.812C272.715 173.469 267.304 206.497 261.157 232.21C255.208 257.094 233.565 264.661 213.228 280.18C191.23 296.967 176.843 321.598 150.7 312.516C125.658 303.818 151.583 265.288 139.03 241.936C128.196 221.781 83.3634 210.479 83.5499 187.599C83.7852 158.748 81.8078 107.714 103.98 89.2591C127.783 69.4472 157.816 114.596 187.695 122.751C216.21 130.534 247.701 123.364 260.905 149.812Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.609 155.002C262.707 175.222 258.097 203.445 252.856 225.416C247.783 246.679 229.298 253.137 211.932 266.392C193.147 280.729 180.866 301.772 158.53 294.001C137.135 286.558 159.267 253.642 148.535 233.682C139.273 216.454 100.971 206.779 101.122 187.226C101.312 162.571 99.6036 118.959 118.537 103.196C138.862 86.2745 164.534 124.869 190.061 131.849C214.422 138.51 241.32 132.396 252.609 155.002Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M248.481 161.384C257.676 179.803 253.459 205.52 248.67 225.542C244.036 244.918 227.182 250.812 211.344 262.897C194.212 275.97 183.007 295.149 162.65 288.081C143.15 281.309 163.342 251.307 153.569 233.125C145.133 217.433 110.223 208.636 110.37 190.821C110.555 168.356 109.02 128.62 126.287 114.248C144.824 98.8198 168.207 133.972 191.474 140.319C213.678 146.377 238.201 140.792 248.481 161.384Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.214 167.429C249.23 183.488 245.549 205.911 241.369 223.369C237.325 240.264 222.626 245.405 208.812 255.945C193.871 267.346 184.096 284.071 166.344 277.911C149.341 272.01 166.954 245.847 158.434 229.996C151.081 216.316 120.638 208.652 120.77 193.118C120.935 173.531 119.603 138.885 134.663 126.352C150.831 112.897 171.216 143.542 191.505 149.073C210.867 154.35 232.254 149.477 241.214 167.429Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M237.886 172.046C245.194 186.687 241.834 207.135 238.02 223.054C234.329 238.46 220.924 243.15 208.325 252.763C194.697 263.161 185.781 278.413 169.593 272.798C154.087 267.42 170.153 243.561 162.385 229.108C155.681 216.634 127.92 209.65 128.041 195.486C128.195 177.626 126.984 146.034 140.72 134.603C155.466 122.332 174.053 150.273 192.555 155.314C210.212 160.124 229.717 155.677 237.886 172.046Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M225.491 184.43C230.634 194.735 228.272 209.124 225.59 220.327C222.995 231.168 213.563 234.467 204.699 241.231C195.111 248.547 188.839 259.279 177.447 255.326C166.536 251.539 177.838 234.751 172.371 224.579C167.652 215.8 148.117 210.882 148.202 200.914C148.308 188.345 147.452 166.112 157.116 158.069C167.491 149.435 182.022 160.063 195.041 163.612C207.466 166.999 219.74 172.91 225.491 184.43Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.511 189.574C223.649 197.856 221.772 209.41 219.635 218.404C217.567 227.108 211.385 232.026 202.905 235.167C199.992 235.516 199.629 235.752 195.252 234.225C186.496 231.17 181.354 229.929 176.956 221.753C173.161 214.697 157.487 210.723 157.542 202.717C157.612 192.623 156.899 174.766 164.64 168.318C172.95 161.397 184.617 169.95 195.063 172.816C205.033 175.552 214.885 180.314 219.511 189.574Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDestination);
export default __webpack_public_path__ + "static/media/Right-Destination.01af5cd5738fe067cd7420cb849264c4.svg";
export { ForwardRef as ReactComponent };